(function (module) {
    'use strict';

    function headerCtrl() {
        this.$onInit = () => {

        };
    }

    module
        .component('headerComponent', {
            templateUrl: '/js/components/header/header.html',
            controller: headerCtrl,
            binding: {

            }
        });
})(angular.module('rocket.components'));
